export default __webpack_public_path__ + "static/media/mp.ca5a851a.svg";